import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnalyticsService } from './analytics.service';
import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { DateTimeStringAdapter } from './date-time-string-adapter.service';
import { FilteringService } from './filtering.service';
import { LoadingService } from './loading.service';
import { SortingService } from './sorting.service';
import { InvoicingService } from './invoice/invoicing.service';
import { RegistrationInvoiceService } from './invoice/registration-invoice.service';
import { RoomBookingInvoiceService } from './invoice/room-booking-invoice.service';
import { ServiceBookingInvoiceService } from './invoice/service-booking-invoice.service';
import { ToastrService } from './toastr.service';
import { StateService } from './state.service';
import { LayoutService } from './layout.service';
import { OpeningDaysAndHoursService } from './opening-days-and-hours.service';
import { DateFormatterService } from './date-formatter.service';
import { RestCountriesService } from './restcountries.service';
import { AppTranslateService } from './app-translate.service';
import { SecurityService } from './security.service';
import { CopyService } from './copy.service';
import { AppAuthService } from './app-auth.service';

const SERVICES = [
  AnalyticsService,
  ApiService,
  DateTimeStringAdapter,
  FilteringService,
  JwtService,
  RoomBookingInvoiceService,
  RegistrationInvoiceService,
  SortingService,
  ToastrService,
  LayoutService,
  StateService,
  OpeningDaysAndHoursService,
  DateFormatterService,
  RestCountriesService,
  LoadingService,
  InvoicingService,
  RegistrationInvoiceService,
  RoomBookingInvoiceService,
  ServiceBookingInvoiceService,
  AppTranslateService,
  SecurityService,
  CopyService,
  AppAuthService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...SERVICES,
  ],
})
export class UtilsModule {
  static forRoot(): ModuleWithProviders<UtilsModule> {
    return {
      ngModule: UtilsModule,
      providers: [
        ...SERVICES,
      ],
    } as ModuleWithProviders<UtilsModule>;
  }
}
